/**
 * Удаление экрана из «Слоёв» с перешивкой переходов (WEB-3765, сводный юнит
 * «редактор: остаток»; решение владельца 29.10 ~19:45 — «как с карты»).
 *
 * Сами экраны и правила считает `removeScreenFrom`
 * (`components/funnel-canvas/canvasEdits.ts`, та же правка, что у карты:
 * переходы, ветки и правила «Логики» на удалённый экран ведут на его выход,
 * правила самого экрана и его блоков уходят с ним) — панель зовёт её и кладёт
 * итог в действие: так хранилище не тянет модуль карты, а правило одно.
 * Тот же приём выноса из фасада, что у `./screenFieldActions.ts` (храповик
 * длины editorSlice.ts); одна правка — один шаг «Отменить»; выбор экрана —
 * как у прежнего `removeScreen` (удалён открытый — открыт первый, блок снят).
 */
import { createAction } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Rule } from '@/logic-engine';
import type { EditorState } from './state';
import type { EditorScreen } from './types/screen';

export interface RemoveScreenRelinkedPayload {
  screenId: string;
  /** Экраны части без удалённого, переходы перешиты. */
  screens: EditorScreen[];
  /** Правила «Логики» после перешивки. */
  logic: Rule[];
}

export const removeScreenRelinked = createAction<
  RemoveScreenRelinkedPayload,
  'editor/removeScreenRelinked'
>('editor/removeScreenRelinked');

export function removeScreenRelinkedReducer(
  state: EditorState,
  action: PayloadAction<RemoveScreenRelinkedPayload>,
): EditorState {
  const { screenId, screens, logic } = action.payload;
  return {
    ...state,
    content: screens,
    logic: [...logic],
    selectedScreenId:
      state.selectedScreenId === screenId
        ? (screens[0]?.id ?? null)
        : state.selectedScreenId,
    selectedBlockId: null,
    isDirty: true,
  };
}
